
'use strict';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookie from 'vue-cookie';
import 'es6-promise/auto';
import Antd from 'ant-design-vue';
import * as VeeValidate from 'vee-validate';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import store from './store';
import mixins from './mixins';
import moment from "moment";
//import './assets/css/antd.css';
import 'ant-design-vue/dist/antd.css';
import App from '@/App';
import router from '@/router';
import VueSocketIO from 'vue-socket.io'
import { URL } from "@/utils/api";


Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueCookie);
Vue.use(Antd);
Vue.use(VeeValidate);
Vue.use(VueAxios, Axios);
// Vue.use(new VueSocketIO({ connection: URL[process.env.NODE_ENV].socket_origin }));



// const socket = new WebSocket(URL[process.env.NODE_ENV].socket_origin);

moment.locale('az');

const app = new Vue({
  el: '#app',
  router: router,
  store: store,
  mixins: mixins,
  components: {
    App
  },
  template: '<App/>',
});